import _ from "lodash";
export const GOOGLE_MAP_API_KEY = `AIzaSyAkWxbuO-maU16USeyELd3UP0hPLITP3Ec`

export const LR_PAR_PAGE_LIST = 20;
export const PAR_PAGE_LIST = 100;

const DevHost = [
  "localhost",
  "transport360.urja360.com",
  "www.transport360.urja360.com"
];

const StagHost = [
  "transport360.urja360.com",
  "www.transport360.urja360.com"
];

const LiveHost = [
  "api.transport360.in",
  "https://api.transport360.in"
];

// export const allowedWidgetDomains = [
//   "http://localhost:3003/",
//   "http://localhost:3002",
// ];

const hostname = window.location.hostname;

const s3_url = ""
const s3_prefix = ""

const regex =
  /(192)\.(168)(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])){2}$/gm;

const live = {
  api_baseurl: "https://api.transport360.in/",
  baseurl: "https://api.transport360.in/",
  socketurl: "",
  s3_url: "",
  s3_prefix: "",
  environment: 'live',
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": "en",
  },
};

const dev = {
  baseurl: `https://transportapi.urja360.com/`,
  api_baseurl: `https://transportapi.urja360.com/`,
  socketurl: "",
  s3_url,
  s3_prefix,
  environment: 'dev',
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": "en",
    "Authorization": "Shailendra"
  },
};

const stag = {
  baseurl: `https://transportapi.urja360.com/`,
  api_baseurl: `https://transportapi.urja360.com/`,
  socketurl: "",
  s3_url: "",
  s3_prefix: "",
  environment: 'stag',
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": "en",
  },
};

const AppConfig = _.includes(DevHost, hostname) || hostname.match(regex)
  ? dev
  : _.includes(LiveHost, hostname)
    ? live
    : _.includes(StagHost, hostname)
      ? stag
      : dev;

export default AppConfig;
